const initialState = {
    adminReportData: null,
    initialData: null,
    allAdmins: null,
    quizAdminReportData: null
}

export const ADMIN_REPORT_ACTION_TYPE = {
    SET_ADMIN_REPORT_DATA: "SET_ADMIN_REPORT_DATA",
    SET_INITIAL_DATA: "SET_INITIAL_DATA",
    SET_ADMINS: "SET_ADMINS",
    SET_QUIZ_ADMIN_REPORT_DATA: "SET_QUIZ_ADMIN_REPORT_DATA"
}

const adminReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case (ADMIN_REPORT_ACTION_TYPE.SET_ADMIN_REPORT_DATA):
            return {
                ...state,
                adminReportData: action.payload
            }
        case (ADMIN_REPORT_ACTION_TYPE.SET_INITIAL_DATA):
            return {
                ...state,
                initialData: action.payload
            }
        case (ADMIN_REPORT_ACTION_TYPE.SET_ADMINS):
            return {
                ...state,
                allAdmins: action.payload
            }
        case (ADMIN_REPORT_ACTION_TYPE.SET_QUIZ_ADMIN_REPORT_DATA):
            return {
                ...state,
                quizAdminReportData: action.payload
            }
        default:
            return state
    }
}

export default adminReportReducer